/**
 * Класс AbstractGeocoder
 */
class AbstractGeocoder {
  constructor(params) {
    this.params = params;
  }

  /**
   * Геокодирование адресной сроки
   * @param params
   */
  geocode(params) {
  }

  /**
   * Получение объектов по коориданатам
   * @param params
   */
  reverseGeocode(params) {
  }
}

module.exports = AbstractGeocoder;